<template>
  <div>
    <div>
      <div class="edume-more">
        <span v-if="moreContentMessage" class="edume-more-content-message">{{
          moreContentMessage
        }}</span>
        <a
          :class="[
            'edume-see-all-link',
            {'edume-is-full-width': !moreContentMessage},
            'edume-link',
          ]"
          :href="dashboardUrl"
          target="_blank"
        >
          {{ linkText }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import {polyglot} from '../utils/polyglot';

export default {
  props: {
    contentCounts: {
      type: Object,
      required: true,
    },
    sections: {
      type: Array,
      required: true,
    },
    dashboardUrl: {
      type: String,
      required: true,
    },
  },
  computed: {
    hasIncompleteContent() {
      return this.sections.length > 0;
    },
    moreContentMessage() {
      const {forYouNotCompleted, allContent} = this.contentCounts;

      if (this.sections.length > 0) {
        if (forYouNotCompleted > 0) {
          const singularText = polyglot.t('MoreContent.forYou.singular');
          const pluralText = polyglot.t('MoreContent.forYou.plural');
          return polyglot.t('MoreContent.forYou.contentCount', {
            count: this.contentCounts.forYouNotCompleted,
            message:
              this.contentCounts.forYouNotCompleted === 1
                ? singularText
                : pluralText,
          });
        }
        if (allContent > 0) {
          return allContent === 1
            ? polyglot.t('MoreContent.allContent.singular', {
                count: allContent,
              })
            : polyglot.t('MoreContent.allContent.plural', {
                count: allContent,
              });
        }
      }
      return '';
    },
    linkText() {
      return this.moreContentMessage
        ? polyglot.t('Widget.seeAll')
        : polyglot.t('Widget.seeAllContent');
    },
  },
};
</script>

<style>
.edume-more {
  display: flex;
  padding: 12px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  align-self: stretch;
  box-shadow:
    0px 1px 2px rgba(32, 32, 33, 0.06),
    0px 2px 8px rgba(32, 32, 33, 0.1);
  margin-top: 12px;
  border-radius: 4px;
}
.edume-see-all-link {
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  text-decoration: none;
}

.edume-is-full-width {
  width: 100%;
}

.edume-more-content-message {
  color: black;
  size: 16px;
  font-weight: 400;
  line-height: 20px;
}
</style>
